import React, { useState } from "react";
import "./not-maximising-modal.scss";
import { Icons } from "../../atoms/Icons";
import { Col, Row } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import { useNavigate } from "react-router-dom";
import { getEmpErValues } from "../../helpers/helpers";

const NotMaximisingModal = (props) => {
  const { data, isSetupAvc, gradeException } = props;
  const [isHovered, setIsHovered] = useState(false);
  const [isEditHovered, setIsEditHovered] = useState(false);
  const navigate = useNavigate();
  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const editHandleMouseEnter = () => {
    setIsEditHovered(true);
  };
  const editHandleMouseLeave = () => {
    setIsEditHovered(false);
  };
  const isContributionMaximised =
    (parseFloat(data?.[props.potIndex]?.potPercentage) ||
      parseFloat(data?.[props.potIndex]?.salarySacrificePercentage)) <
    parseFloat(data?.[props.potIndex]?.eeMax);
  return (
    <div className="main-maximising-modal">
      <Row>
        <Col className="your-monthly-modal-close-btn mt-4">
          <div className="close-icon-container">
            <Icons
              iconname="close-large-white"
              variant="icon-sixteen-px"
              clickHandler={props.handleCloseButton}
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg={1} md={1} xs={1} className="error-icon-style">
          <Icons iconname="error" variant="icon-twenty-four-px" />
        </Col>
        <Col>
          {isSetupAvc ? (
            <p className="reg-contri-mod-heading">Set up a new AVC</p>
          ) : (
            <p className="reg-contri-mod-heading">
              Change your regular contributions
            </p>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          {isSetupAvc ? (
            <p className="reg-contr-mod-subHead is-setup-avc">
              To set up voluntary contributions on your account, please download
              an AVC application form and share the completed form with your
              employer.
            </p>
          ) : (
            <p className="reg-contr-mod-subHead">
              You’re currently not making the most of your regular
              contributions.{" "}
              {!gradeException && (
                <>
                  {"You can receive up to "}
                  {getEmpErValues(data?.[props.potIndex])?.erValue}% from your
                  employer for a member contribution of{" "}
                  {getEmpErValues(data?.[props.potIndex])?.empValue}%.
                </>
              )}
              <br /> <br />
              We suggest maximising your pension before making additional
              voluntary contributions.
            </p>
          )}
        </Col>
      </Row>

      <Row className="mt-2">
        <Col
          xl={isContributionMaximised ? 4 : 12}
          lg={isContributionMaximised ? 5 : 12}
          md={isContributionMaximised ? 5 : 12}
          className={!isContributionMaximised ? "text-end" : ""}
        >
          <Buttons
            className="outline-light"
            handleClick={() => {
              if (isSetupAvc) {
                navigate("/messages-and-documents?tab=schemeDocuments");
              } else {
                navigate("/manage/av-contribution", {
                  state: { potIndex: props.potIndex },
                });
              }
              props.handleCloseButton;
            }}
            iconname={isHovered ? "arrow-right" : "arrow-right-white"}
            variantname="icon-sixteen-px ms-1"
            name={isSetupAvc ? "To Scheme documents" : "Continue to AVC"}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          />
        </Col>
        {isContributionMaximised ? (
          <Col xl={5} lg={5} md={5} className="maximising-btn-style">
            <Buttons
              handleClick={() => {
                navigate("/manage/regular-contribution", {
                  state: { potIndex: props.potIndex },
                });
                props.handleCloseButton;
              }}
              iconname={isEditHovered ? "arrow-right-white" : "arrow-right"}
              variantname="icon-sixteen-px ms-1"
              name="Edit Contributions"
              className="secondary"
              onMouseEnter={editHandleMouseEnter}
              onMouseLeave={editHandleMouseLeave}
            />
          </Col>
        ) : (
          ""
        )}
      </Row>
    </div>
  );
};

export default NotMaximisingModal;
